// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"PageTitle_PageTitle__2ICpE","PageTitleOverlay":"PageTitle_PageTitleOverlay__1BkTv"};